module.exports = "<div>\r\n  <app-bought-modal v-if='bought'></app-bought-modal>\r\n  <div class=\"full-min-height flex flex-column\">   \r\n    <app-header></app-header>\r\n    <app-overview :products=\"products\"></app-overview> \r\n  </div>\r\n  <app-showcase :products=\"products\"></app-showcase>\r\n  <app-footer></app-footer>\r\n</div>\r\n\r\n";


//////////////////
// WEBPACK FOOTER
// ./lib/home-view/index.html
// module id = 46
// module chunks = 0